<template>
  <svg
    :width="width"
    :height="width"
    :viewBox="tile ? '0 0 48 48' : '12 12 24 24'"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-if="tile"
      d="M0 8.41129C0 3.76586 3.76586 0 8.41129 0H39.5887C44.2341 0 48 3.76586 48 8.41129V39.5887C48 44.2341 44.2341 48 39.5887 48H8.41129C3.76586 48 0 44.2341 0 39.5887V8.41129Z"
      fill="#F0F2FA"
    />
    <path
      d="M21.0571 13.2031H15.1663C14.6458 13.2038 14.1469 13.4108 13.7788 13.7788C13.4108 14.1469 13.2038 14.6458 13.2031 15.1663V21.0571C13.2034 21.5778 13.4103 22.0771 13.7784 22.4454C14.1465 22.8137 14.6456 23.0209 15.1663 23.0215H21.0571C21.578 23.0212 22.0775 22.8141 22.4458 22.4458C22.8141 22.0775 23.0212 21.578 23.0215 21.0571V15.1663C23.0209 14.6456 22.8137 14.1465 22.4454 13.7784C22.0771 13.4103 21.5778 13.2034 21.0571 13.2031Z"
      :fill="color"
    />
    <path
      opacity="0.6"
      d="M32.8384 13.2031H26.9476C26.4271 13.2038 25.9281 13.4108 25.5601 13.7788C25.1921 14.1469 24.985 14.6458 24.9844 15.1663V21.0571C24.985 21.5776 25.1921 22.0766 25.5601 22.4446C25.9281 22.8126 26.4271 23.0197 26.9476 23.0203H32.8384C33.3589 23.0197 33.8578 22.8126 34.2259 22.4446C34.5939 22.0766 34.8009 21.5776 34.8016 21.0571V15.1663C34.8009 14.6458 34.5939 14.1469 34.2259 13.7788C33.8578 13.4108 33.3589 13.2038 32.8384 13.2031Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M21.0571 24.9844H15.1663C14.6458 24.985 14.1469 25.1921 13.7788 25.5601C13.4108 25.9281 13.2038 26.4271 13.2031 26.9476V32.8384C13.2038 33.3589 13.4108 33.8578 13.7788 34.2259C14.1469 34.5939 14.6458 34.8009 15.1663 34.8016H21.0571C21.5776 34.8009 22.0766 34.5939 22.4446 34.2259C22.8126 33.8578 23.0197 33.3589 23.0203 32.8384V26.9476C23.0197 26.4271 22.8126 25.9281 22.4446 25.5601C22.0766 25.1921 21.5776 24.985 21.0571 24.9844Z"
      :fill="color"
    />
    <path
      d="M29.9632 32.6625V30.6382H27.9388C27.8945 30.6382 27.8508 30.6293 27.8099 30.6124C27.769 30.5955 27.7316 30.5706 27.7003 30.5393C27.669 30.508 27.6443 30.4709 27.6273 30.43C27.6104 30.3891 27.6016 30.3453 27.6016 30.301C27.6016 30.2567 27.6104 30.2128 27.6273 30.1719C27.6443 30.131 27.669 30.0938 27.7003 30.0625C27.7316 30.0312 27.769 30.0064 27.8099 29.9894C27.8508 29.9725 27.8945 29.9638 27.9388 29.9638H29.9644V27.9394C29.9644 27.8498 30 27.7638 30.0634 27.7004C30.1267 27.6371 30.2126 27.6016 30.3021 27.6016C30.3917 27.6016 30.4776 27.6371 30.5409 27.7004C30.6043 27.7638 30.6399 27.8498 30.6399 27.9394V29.9649H32.6644C32.7539 29.9649 32.8398 30.0005 32.9031 30.0638C32.9665 30.1272 33.0021 30.2131 33.0021 30.3027C33.0021 30.3923 32.9665 30.4783 32.9031 30.5417C32.8398 30.605 32.7539 30.6405 32.6644 30.6405H30.6399V32.6661C30.6399 32.7555 30.6044 32.8414 30.5412 32.9046C30.478 32.9678 30.3922 33.0033 30.3027 33.0033C30.2133 33.0033 30.1275 32.9678 30.0643 32.9046C30.001 32.8414 29.9655 32.7555 29.9655 32.6661L29.9632 32.6625Z"
      :fill="color"
      :stroke="color"
      stroke-width="1.2"
    />
  </svg>
</template>
<script setup lang="ts">
import { type CbIconProps, cbIconDefaults } from "../cb-icon.props";

// `tile` draws the empty-state illustration; without it this is a nav-sized glyph.
withDefaults(defineProps<CbIconProps & { tile?: boolean }>(), {
  ...cbIconDefaults,
  tile: false,
});
</script>
